import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Opcion } from '../../models/opcion.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-multiple-option',
  templateUrl: './multiple-option.component.html',
  styleUrl: './multiple-option.component.scss'
})
export class MultipleOptionComponent {

  @Input() options: Opcion[] = [];
  @Input() selected: Opcion[] = [];
  @Output() selectedChange = new EventEmitter<Opcion[]>();

  public answerMaxLength: number = environment.limits.answerMaxLength;

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR onSelect                              */
  /* -------------------------------------------------------------------------- */
  // region onSelect
  onSelect(
    option: Opcion,
    event: Event
  ) {
    const isChecked: boolean = (event.target as HTMLInputElement).checked;
    // console.log(isChecked);
    // console.log(option);

    if(isChecked) {
      this.selected.push(option);
      this.selectedChange.emit(this.selected);
    } else {

      option.respuestaTexto = '';

      this.selected = this.selected.filter(
        r => r.idRespuesta !== option.idRespuesta
      );
      this.selectedChange.emit(this.selected);
    }

    // console.log(this.selected);
    
  }

}
